import React, { Component } from "react";
import PropTypes from "prop-types";
import CustomModal from "./CustomModal";
import { Image, Button } from "react-bootstrap";
// import { InformationApi } from './Api';
import alert from "../../assets/images/carbon-warning-filled.svg";

class InformationModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: "",
      email: "",
      inProgress: false,
    };
  }
  componentDidMount() {}

  render() {
    return (
      <CustomModal
        show={this.props.show}
        onHide={this.props.handleClose}
        title={""}
        modalClass={"information-modal"}
      >
        <div className="information-modal-wrapper">
          <p className="inter-Medium f-s-14 lh-17">
            <Image src={alert} />
            &nbsp;&nbsp;&nbsp; Are you sure you want to Delete this?
          </p>
          <div className="submit-wrapper">
            <Button className="secondary-btn">Yes</Button>
            <Button onClick={this.props.handleClose} className="primary-btn">
              No
            </Button>
          </div>
        </div>
      </CustomModal>
    );
  }
}

InformationModal.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};
export default InformationModal;
